import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

// Used only by the chatbot (the main API authenticates via the SWA linked
// backend). The registration doubles as the chatbot API's audience — see the
// scope in msal-chatbot.ts.
const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: `${window.location.origin}/redirect.html`,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
